export const PrivNfzStateIcon = () => {
  return (
    <svg
      width="20"
      height="9"
      viewBox="0 0 20 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9667 0.00413364C16.2589 0.00413364 16.4958 0.241023 16.4958 0.53324V3.22848C16.4958 4.70339 16.8614 6.15068 17.554 7.44293C18.2465 6.15068 18.6121 4.70342 18.6122 3.22851V0.53324C18.6122 0.241023 18.8491 0.00413364 19.1413 0.00413364C19.4335 0.00413364 19.6704 0.241023 19.6704 0.53324V3.22851C19.6703 5.19878 19.0871 7.12498 17.9942 8.76438C17.8961 8.91158 17.7309 9 17.554 9C17.3771 9 17.2119 8.91158 17.1137 8.76438C16.0209 7.12498 15.4377 5.1988 15.4376 3.22853V0.53324C15.4376 0.241023 15.6745 0.00413364 15.9667 0.00413364Z"
        fill="#3D3D3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5089 0.00206682C6.80112 0.00206682 7.038 0.238956 7.038 0.531173C7.038 0.823391 7.038 8.46777 7.038 8.46777C7.038 8.75998 6.80112 8.99687 6.5089 8.99687C6.21668 8.99687 5.97979 8.75998 5.97979 8.46777V0.531173C5.97979 0.238956 6.21668 0.00206682 6.5089 0.00206682Z"
        fill="#3D3D3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.98393 0.53324C5.98393 0.241023 6.22082 0.00413364 6.51303 0.00413364H7.69929C8.36585 0.00413364 9.0051 0.268921 9.47643 0.740249C9.94776 1.21158 10.2125 1.85083 10.2125 2.51739C10.2125 3.18395 9.94776 3.8232 9.47643 4.29453C9.0051 4.76586 8.36585 5.03064 7.69929 5.03064H6.51303C6.22082 5.03064 5.98393 4.79376 5.98393 4.50154C5.98393 4.20932 6.22082 3.97243 6.51303 3.97243H7.69929C8.08519 3.97243 8.45529 3.81913 8.72816 3.54626C9.00103 3.27339 9.15433 2.90329 9.15433 2.51739C9.15433 2.13149 9.00103 1.76139 8.72816 1.48852C8.45529 1.21564 8.08519 1.06235 7.69929 1.06235H6.51303C6.22082 1.06235 5.98393 0.825457 5.98393 0.53324Z"
        fill="#3D3D3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0299 4.04585C7.28047 3.8955 7.60548 3.97675 7.75583 4.22733L10.1368 8.19562C10.2871 8.4462 10.2059 8.77121 9.95532 8.92155C9.70475 9.0719 9.37974 8.99064 9.22939 8.74007L6.84842 4.77177C6.69807 4.5212 6.77932 4.19619 7.0299 4.04585Z"
        fill="#3D3D3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7021 0C12.9943 0 13.2312 0.236889 13.2312 0.529106V8.4657C13.2312 8.75792 12.9943 8.99481 12.7021 8.99481C12.4099 8.99481 12.173 8.75792 12.173 8.4657V0.529106C12.173 0.236889 12.4099 0 12.7021 0Z"
        fill="#3D3D3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.858208 0C1.15043 0 1.38731 0.236889 1.38731 0.529106V8.4657C1.38731 8.75792 1.15043 8.99481 0.858208 8.99481C0.565991 8.99481 0.329102 8.75792 0.329102 8.4657V0.529106C0.329102 0.236889 0.565991 0 0.858208 0Z"
        fill="#3D3D3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333235 0.531173C0.333235 0.238956 0.570124 0.00206682 0.862342 0.00206682H1.656C2.4278 0.00206682 3.16799 0.308665 3.71374 0.854411C4.25949 1.40016 4.56609 2.14035 4.56609 2.91215C4.56609 3.68395 4.25949 4.42415 3.71374 4.96989C3.16799 5.51564 2.4278 5.82224 1.656 5.82224H0.862342C0.570124 5.82224 0.333235 5.58535 0.333235 5.29313C0.333235 5.00091 0.570124 4.76402 0.862342 4.76402H1.656C2.14715 4.76402 2.61818 4.56892 2.96547 4.22162C3.31277 3.87433 3.50787 3.4033 3.50787 2.91215C3.50787 2.421 3.31277 1.94997 2.96547 1.60268C2.61818 1.25539 2.14715 1.06028 1.656 1.06028H0.862342C0.570124 1.06028 0.333235 0.823391 0.333235 0.531173Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};
